import React from 'react'
import { BottomSheetType } from 'src/types/SchoolType';
import { getDateDifference, getDatePast } from 'src/utils/DateUtils';
import { styled, Box, Typography } from '@mui/material';

import e2 from "src/assets/images/marker_Element_2.svg"
import e4 from "src/assets/images/marker_Element_4.svg"
import normal from "src/assets/images/marker_Element_normal.svg"
import specialize from "src/assets/images/marker_Element_specialize.svg"
import purpose from "src/assets/images/marker_Element_purpose.svg"
import self from "src/assets/images/marker_Element_self.svg"
import WatchIcon from '@mui/icons-material/WatchLater';
import StarIcon from '@mui/icons-material/Star';
import Etc from "src/assets/images/marker_Element_Etc.svg"

interface Props {
    school: BottomSheetType
    setState : React.Dispatch<React.SetStateAction<BottomSheetType | null>>
}

interface BadgeIconProps{
    color: string;
}

const BadgeIcon = styled('div')<BadgeIconProps>(({ color }) => ({
    borderRadius: '100%',
    backgroundColor: color,
    minWidth: '30px',
    minHeight: '30px',
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    marginBottom:'auto'
  }));

// 학교 항목 스타일링
const SchoolItem = styled('div')({ display: 'flex', alignItems: 'center', padding: '16px 0', borderBottom: '1px solid #d3d3d3', });

const BoxContainer = styled('div')({
    display:'flex',
    flexDirection:'column',
    marginLeft:'9px',
})

const SchoolList = ({school, setState}:Props) => {
    let color = "#F57749"
    let visited_At = '방문 기록 없음'
    if (school.visited_at){
        const datediff = getDateDifference(school.visited_at)
        if (datediff <= 180) { color = "#57C0AA";} 
        else if (datediff <= 365) { color = "#5CA8E4";} 
        else if (datediff <= 730) { color = "#F5BE49";}
        else if (datediff >= 730) { color = "#F57749";}
        visited_At = getDatePast(school.visited_at)
    }
    else{
        color = "#F57749"
    }
    let iconic = '';
    // 대학/전문대학 조건
    if (school.school_type === '전문대학') {
      iconic = e2;
    } else if (school.school_type?.includes('대학')) {
      iconic = e4;
    } else if (school.school_type === '훈련소' || school.school_type === null){
      iconic = Etc
    }
    // 고등학교 타입 조건
    if (school.school_type === '일반고등학교') {
      iconic = normal;
    } else if (school.school_type === '특성화고등학교') {
      iconic = specialize;
    } else if (school.school_type === '특수목적고등학교') {
      iconic = purpose;
    } else if (school.school_type === '자율고등학교') {
      iconic = self;
    }

    let parseType = ''
      if (school.school_type === '특성화고등학교') {
        parseType = '특성화고'
      } else if (school.school_type === '특수목적고등학교') {
        parseType = '특목고'
      } else if (school.school_type === '자율고등학교') {
        parseType = '자율고'
      }

          // 학교 클릭 시 상세 정보 표시
    const handleSchoolClick = (school: BottomSheetType) => {
        setState?.(school);
        };

  return (
    <div>
        <SchoolItem onClick={() => handleSchoolClick(school)}>
            <BadgeIcon color={color}>
                <img src={iconic} alt="학교 아이콘" style={{width:'15px',height:'15px'}}/>
            </BadgeIcon>
            <BoxContainer style={{width:'100%'}}>
                <Box display="flex" alignItems="center" sx={{ marginBottom: "4px"}}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize:'16px'}}>
                    {school.school_name}
                    </Typography>
                    {parseType &&
                    <Typography variant="body2" sx={{ marginBottom: "4px", color: '#1E9468', padding: '3px 7px', border: '1px solid #1E9468', borderRadius: '3px', display: 'inline-block', marginLeft: '12px', fontSize: '12px'}}>
                    {parseType}
                    </Typography>
                    }
                </Box>
                <Typography variant="body2" display="flex" alignItems="center" sx={{opacity:0.5}}>
                    <WatchIcon fontSize="small" sx={{ color: 'gray', marginRight: 1 }} />
                    미방문 기간 | {visited_At}
                </Typography>
                <Typography variant="body2" display="flex" alignItems="center"sx={{opacity:0.5}}>
                    <StarIcon fontSize="small" sx={{ color: 'gray', marginRight: 1 }} />
                    직전 관심표명자 수 | {school.interested_cnt}명
                </Typography>
            </BoxContainer>
        </SchoolItem>
    </div>
  )
}

export default SchoolList